import { showApiErrors } from '@/utils';
import { createSlice, isPending, isRejected } from '@reduxjs/toolkit';
import { pick } from 'lodash';
import { PaginationFields } from '@/models/pagination.model';
import { createMetatagsTemplate, getMetatags, updateMetatagsTemplate, deleteMetatagsTemplate } from './actionCreators';
import { MetatagsState, SLICE_NAME, initialState } from './models';

export const metatagsSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMetatags.fulfilled, (state: MetatagsState, action) => {
        const { payload } = action;
        state.metatags = payload?.metatags ?? [];
        state.pagination = pick(payload, [PaginationFields.PAGE_SIZE, PaginationFields.TOTAL, PaginationFields.PAGE]);
        state.isLoading = false;
      })
      .addCase(createMetatagsTemplate.fulfilled, (state: MetatagsState) => {
        state.isLoading = false;
      })
      .addCase(updateMetatagsTemplate.fulfilled, (state: MetatagsState, action) => {
        const { payload } = action;
        state.isLoading = false;
        state.metatags = (state.metatags ?? []).map((metatag) => {
          if (metatag.id === payload.id) return payload;
          return metatag;
        });
      })
      .addCase(deleteMetatagsTemplate.fulfilled, (state: MetatagsState, action) => {
        const { meta } = action;
        state.isLoading = false;
        state.metatags = (state.metatags ?? []).filter((metatag) => metatag.id !== meta.id);
      })
      .addMatcher(
        isPending(getMetatags, createMetatagsTemplate, updateMetatagsTemplate, deleteMetatagsTemplate),
        (state: MetatagsState) => {
          state.isLoading = true;
          state.error = null;
        },
      )
      .addMatcher(
        isRejected(getMetatags, createMetatagsTemplate, updateMetatagsTemplate, deleteMetatagsTemplate),
        (state: MetatagsState, action) => {
          const { error } = action;
          state.isLoading = false;
          state.error = error;
          showApiErrors(error);
        },
      );
  },
});
